export const FIREBASE_ID_TOKEN_COOKIE = "flowpos-firebase-id-token";
export const DEFAULT_COOKIES_EXPIRATION = new Date(
	Date.now() + 1000 * 60 * 60 * 24 * 7,
);
